import Login from 'components/auth/login/Login';
import RegisterOrganization from 'components/organization/RegisterOrganization';
import ForgotPassword from 'components/auth/login/ForgotPassword';
import AuthTwostepVerification from 'components/auth/login/TwoFactorAuthenticate';
import ResetPassword from 'components/auth/login/ResetPassword';
import UserManagement from 'components/userManagement/UserManagement';
import OffBoarding from 'components/userManagement/OffBoarding';
import Listorganization from 'components/Superadminaccess/Listorganization';
import SignInOTP from 'components/auth/login/SignInOTP';
import DashboardPage from 'views/admin/taskManagement/components/DashboardPage';
import Features from 'views/admin/features/components/Features';
import LoginUI from 'components/auth/login/LoginWithFeature';
import NewTabEpicdetails from 'views/admin/taskManagement/Timeline/NewTabEpicdetails';
import NewTabtaskdetails from 'views/admin/taskManagement/Board/NewTabtaskdetails';
import Newtabsubtaskdetails from 'views/admin/taskManagement/Board/Newtabsubtaskdetails';
import Confluence from 'views/admin/confluence/Confluence';
import OrganizationRegister from 'components/auth/login/OrganisationRegister';
import SuperadminDashboard from 'components/subscriptionManagement/SuperadminDashboard';

const publicRoutes = [
  { path: '/login', component: LoginUI },
  { path: '/login/forgotpassword', component: ForgotPassword },
  {
    path: '/login/forgotpassword/authenticate',
    component: AuthTwostepVerification,
  },
  { path: '/login/forgotpassword/resetpassword', component: ResetPassword },
  { path: 'login/signinotp', component: SignInOTP },
  {path:'/login/register', component: RegisterOrganization},
];

const authProtectedRoutes = [
  { path: '/login/register', component: RegisterOrganization },
  { path: '/user-management', component: UserManagement },
  { path: '/off-boarding', component: OffBoarding },
  { path: '/listorganization', component: Listorganization },
  { path: '/taskBoard/:id', component: DashboardPage },
  { path: '/features', component: Features },
  // {path:'/subscription', component: SuperadminDashboard},
  {
    path: '/taskBoard/:projectId/:issuetypeId/taskDetails/:taskId',
    component: NewTabtaskdetails,
  },
  {
    path: '/timeline/:projectId/EpicDetails/:epicId',
    component: NewTabEpicdetails,
  },
  {
    path: '/taskBoard/:projectId/subtaskDetails/:subtaskId',
    component: Newtabsubtaskdetails,
  },
  { path: '/confluence/*', component: Confluence },
];

export { publicRoutes, authProtectedRoutes };
